
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-team/[type]/[page]",
      function () {
        return require("private-next-pages/our-team/[type]/[page]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-team/[type]/[page]"])
      });
    }
  